import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueObserveVisibility from 'vue-observe-visibility'
import * as LottiePlayer from "@lottiefiles/lottie-player";

Vue.use(VueObserveVisibility);
Vue.use(LottiePlayer);

import MediaArtwork from './components/MediaArtwork.vue'
import MediaItem from './components/MediaItem.vue'
import PrintMediaItem from './components/PrintMediaItem.vue'
import MediaPreviewButton from './components/MediaPreviewButton'
import NavAppLinks from './components/NavAppLinks.vue'
import Career from './components/Career.vue'

Vue.component("media-artwork", MediaArtwork);
Vue.component("media-item", MediaItem);
Vue.component("print-media-item", PrintMediaItem);
Vue.component("media-preview-button", MediaPreviewButton);
Vue.component("nav-app-links", NavAppLinks);
Vue.component("career", Career);

Vue.config.productionTip = false

//import './assets/css/font-awesome.min.css'
import '../public/css/style.css'
//import './assets/js/main.js'

new Vue({
  data: {
      "now_playing": {},
      "country": "US",
      "app_link": {
          "aog": "https://assistant.google.com/services/a/uid/000000695a2a1b21",
          "alexa": "https://amzn.to/2OTLGwD",
          "firetv": "https://amzn.to/30hOI0r",
          "android": "https://play.google.com/store/apps/details?id=com.sleepjar.android",
          "ios": "https://apps.apple.com/us/app/sleep-jar/id1587218079"
      },
      "quick_launch": {
          "aog": "https://assistant.google.com/services/invoke/uid/000000695a2a1b21?intent=actions.intent.MAIN&utm_source=sleepjar&utm_medium=website&hl=en",
          "alexa": "https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.736c6efe-b44f-40fa-b280-980b59807e81/tasks/PlaySound/versions/1?a2z_ref=website"
      }
  },
  computed: {
      /*
      "alexaQuickLink": function(){
          if(this.$root.country == "US"){
              return "https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.032710b4-ae33-4f97-a8cf-d352a647b749/tasks/PlaySound/versions/1?a2z_ref=footer";
          }else{
              return "https://amzn.to/3juXvno";
          }
      }
      */
  },
  methods: {
      "removePlaying": function(pool, key){
          if(this.now_playing[pool] == undefined){
              this.now_playing[pool] = [];
          }
          console.log("remove key: " + key);
          var index = this.now_playing[pool].indexOf(key);
          console.log("remove index: " + index);
          if(index > -1){
              var spliced = this.now_playing[pool].splice(index, 1);
              console.log("spliced: " + spliced);
          }
          console.log(this.now_playing[pool]);
          return this.now_playing[pool];
      },
      "addPlaying": function(pool, key){
          if(this.now_playing[pool] == undefined){
              this.now_playing[pool] = [];
          }

          console.log("add key: " + key);
          this.now_playing[pool].push(key);
          console.log(this.now_playing[pool]);
          return this.now_playing[pool];
      }
  },
  mounted(){
      /*
      fetch('https://patient-flower-9308.invokedapps.workers.dev/')
      .then(response => response.json())
      .then(data => {
          if(data && data.country){
              console.log("COUNTRY RETRIEVED: " + data.country);
              this.country = data.country;
          }
      });
      */
  },
  router,
  render: h => h(App)
}).$mount('#app')
